import * as React from 'react';

import {
  Input,
} from '@revfluence/fresh';
import { Textarea } from '@frontend/shadcn/components/ui/textarea';

export interface IProps {
  intro: string;
  onUpdateIntro: (description: string) => void;
  showFlexUI?: boolean;
}

const Intro: React.FC<IProps> = React.memo(
  ({
    intro,
    onUpdateIntro,
    showFlexUI,
  }) => {
    if (showFlexUI) {
      return (
        <div className="p-0.5">
          <Textarea
            rows={2}
            placeholder="Enter introduction..."
            value={intro}
            onChange={(e) => onUpdateIntro(e.target.value)}
            maxLength={1000}
            className="rounded-lg placeholder:text-mask"
          />
        </div>
      );
    }

  return (
    <Input.TextArea
      rows={4}
      placeholder="Enter..."
      value={intro}
      onChange={(e) => onUpdateIntro(e.target.value)}
      maxLength={1000}
    />
    );
  },
);

Intro.displayName = 'Intro';

export default Intro;
